import { Button, DatePicker, Form, Input, InputNumber, Modal, Radio, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FormWrapper, GoBackBtn, Header, Wrapper } from './styles';

import { DeleteOutlined, LeftOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import UploadImg from '../../../../components/uploadImage';
import { financeCategoryList } from '../../../../constants/finance';
import { useAddFinance, useDeleteFinance, useFinance, useFinances } from '../../../../zustand/store';
import { AddButton } from '../styles';
// import { GoBackBtn } from '../../styles';


const DeleteSection = () => {
    const [open, setOpen] = useState(false);
    let { id } = useParams();
    const del = useDeleteFinance();
    const finances = useFinances();
    const navigate = useNavigate();


    const confirmDelete = () => {
        del.execute({
            params: { id },
            onSuccess: () => {
                // finances.execute({ params: { carId }, force: true });
                navigate(`/finance`);
            }
        });
    }

    return (
        <>
            <Button danger size='large' onClick={() => setOpen(true)} >
                {/* Delete */}
                <DeleteOutlined />
            </Button>
            <Modal
                onOk={confirmDelete}
                title="Delete" centered open={open} onCancel={() => setOpen(false)} okText="Delete" okButtonProps={{ danger: true }}>
                Do you really want to delete this?
            </Modal>
        </>
    )
}


function FinanceForm() {
    const [imgList, setImgList] = useState([]);
    const [category, setCategory] = useState("General");
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    let { id } = useParams();
    const addFinance = useAddFinance();
    const finances = useFinances();
    const finance = useFinance();

    const [form] = Form.useForm();

    useEffect(() => {
        if (id) {
            finance.execute({
                params: { id }, force: true,
                onSuccess: (res) => {
                    const data = res.data;
                    setCategory(data.category);
                    form.setFieldsValue({
                        // category: data.category,
                        // make: data.make,
                        // model: data.model,
                        // color: data.color,
                        // year: dayjs(data.year),
                        // mileage: data.mileage,
                        price: data.price,
                        note: data.note,
                        addedAt: dayjs(data.addedAt)
                    })
                    setImgList(data.images)
                    // console.log(data);
                }
            });
        }
        const c = searchParams.get("c");
        if (c) {
            setCategory(c);
        }
    }, [])

    return (
        <Wrapper>
            <Header>
                <GoBackBtn onClick={() => {
                    // if (id) {
                    //     navigate(`/car/${carId}/expense/${id}`);
                    // } else {
                    navigate(`/finance`);
                    // }
                }}>
                    <LeftOutlined />
                </GoBackBtn>
                {
                    id && <DeleteSection />
                }
            </Header>
            <UploadImg imgList={imgList} setImgList={setImgList} />
            <FormWrapper>
                <Form size='large' layout='vertical'
                    form={form}
                    onFinish={(e) => {
                        // e.year = e.year.year();
                        e.addedAt = (e.addedAt || dayjs());
                        // e.addedAt = e.addedAt.format("DD/MM/YYYY");
                        console.log(e);
                        e.images = imgList?.filter(({ photo }) => photo.length)?.map(({ photo, main }) => ({ photo, main }));
                        e.image = imgList?.find(({ main }) => main)?.photo;
                        e.category = category;
                        e.type = e.type || (category === "Sold" ? "income" : "expense")
                        addFinance.execute({
                            data: e, params: { id },
                            onSuccess: () => {
                                navigate(`/finance`);
                                // finances.execute({ params: { carId }, force: true });
                            }
                        })

                            ;
                        // (id ? editCar : addCar).execute({
                        //     params: { id },
                        //     data: e, onSuccess: (res) => {
                        //         const data = res.data;
                        //         id = (id || data.id);
                        //         navigate(`/car/${carId}`);
                        //     }
                        // })
                    }}
                >
                    {category !== "Sold" &&
                        <>
                            {(category === "Part" || category === "Other") &&
                                <Form.Item label=" " name={"type"}>
                                    <Radio.Group optionType='button' buttonStyle="solid" defaultValue={"expense"}>
                                        <Radio value={"expense"}>
                                            Buy
                                        </Radio>
                                        <Radio value={"income"}>
                                            Sell
                                        </Radio>
                                    </Radio.Group>
                                    {/* <InputNumber style={{ width: "100%" }} /> */}
                                </Form.Item>}
                        </>
                    }
                    <Form.Item label="Price" name={"price"}>
                        <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label="AddedAt" name={"addedAt"}>
                        <DatePicker format="DD/MMM/YYYY" allowClear={false} defaultValue={dayjs()} style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label="Note" name={"note"}>
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type='primary' block htmlType='submit'>
                            {
                                id ? "Update" : category === "Sold" ? "Mark as sold out" : "Save"}
                        </Button>
                    </Form.Item>
                </Form>
            </FormWrapper>
        </Wrapper>
    )
}

export default FinanceForm